<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/zgp.png" /></div>
      <p>ZGP</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/zgp/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "1.0.0",
          linkList: [ur + "1.0.0/zgp-sdk.js", ur + "1.0.0/zgp-sdk.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZGP.vue